import { Image } from "./plugin/index.js";
// import { ImageElement, ImageElementProps, ImageUploadResponse } from "./types";
import "./styles.css";

// declare module 'slate' {
//   interface CustomTypes {
//     Element: ImageElement;
//   }
// }

export { ImageCommands } from "./commands/index.js";

export default Image;
// export { ImageElement, ImageElementProps, ImageUploadResponse };
